import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import p5 from 'p5';

import { fastStroke, fastBackground } from '../../util/color';

import Line from './Line';

import styles from './Lines.styl';

class Lines extends PureComponent {

  constructor(props) {
    super(props);
    this.lines = [];
  }

  componentDidMount() {
    this.sketch = this.init();
  }

  componentDidUpdate() {
    // Redraw
    this.sketch.remove();
    this.sketch = this.init();
  }

  init() {
    const { width, height } = this.props;
    const setCurrentLine = (line) => { this.currentLine = line; };
    const getCurrentLine = () => this.currentLine;
    setCurrentLine(new Line(height));

    /* eslint-disable no-param-reassign */
    // eslint-disable-next-line new-cap
    return new p5((p) => {
      let stroke = 'black';

      p.setup = function setup() {
        p.createCanvas(width, height);
        fastBackground(p, 'white');
        fastStroke(p, stroke);
        p.frameRate(60);
      };

      p.draw = function draw() {
        const currentLine = getCurrentLine();

        if (currentLine.minX >= width) {
          stroke = (stroke === 'black' ? 'white' : 'black');
          fastStroke(p, stroke);
          p.strokeWeight(stroke === 'white' ? 5 : 1);
          setCurrentLine(new Line(height));
          return;
        }

        // Draw, which returns a boolean indicating whether we need to add a new line
        if (currentLine.drawAllCurve(p)) {
          setCurrentLine(new Line(height, currentLine));
        }
      };

    }, this.container);
    /* eslint-enable no-param-reassign */
  }

  render() {
    return (
      <div className={styles.Lines} ref={node => (this.container = node)} />
    );
  }
}

Lines.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default Lines;



// WEBPACK FOOTER //
// ./components/Lines/Lines.jsx